var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0074BD;}\r\n\t.st1{fill:#EA2D2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M216.3,261.3c0,0-9.7,5.6,6.9,7.5c20.1,2.3,30.4,2,52.5-2.2c0,0,5.8,3.7,14,6.8 C240,294.7,177.3,272.2,216.3,261.3L216.3,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M210.2,233.5c0,0-10.9,8.1,5.7,9.8c21.5,2.2,38.4,2.4,67.8-3.3c0,0,4.1,4.1,10.4,6.4 C234.2,263.9,167.3,247.7,210.2,233.5L210.2,233.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st1",
    d: "M261.4,186.3c12.2,14.1-3.2,26.8-3.2,26.8s31.1-16,16.8-36.1c-13.3-18.7-23.6-28,31.8-60.1 C306.8,116.8,219.9,138.5,261.4,186.3L261.4,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M327.1,281.8c0,0,7.2,5.9-7.9,10.5c-28.7,8.7-119.4,11.3-144.5,0.3c-9-3.9,7.9-9.4,13.3-10.6 c5.6-1.2,8.7-1,8.7-1c-10.1-7.1-65.1,13.9-27.9,20C270,317.5,353.4,293.7,327.1,281.8L327.1,281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M221,204.7c0,0-46.1,11-16.3,14.9c12.6,1.7,37.6,1.3,61-0.7c19.1-1.6,38.3-5,38.3-5 s-6.7,2.9-11.6,6.2c-46.8,12.3-137.3,6.6-111.3-6C203.1,203.5,221,204.7,221,204.7L221,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M303.7,250.9c47.6-24.7,25.6-48.5,10.2-45.3c-3.8,0.8-5.4,1.5-5.4,1.5s1.4-2.2,4.1-3.1 c30.4-10.7,53.8,31.5-9.8,48.2C302.8,252.2,303.5,251.5,303.7,250.9L303.7,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M275,65c0,0,26.4,26.4-25,66.9c-41.2,32.5-9.4,51.1,0,72.3c-24.1-21.7-41.7-40.8-29.9-58.6 C237.5,119.6,285.6,106.9,275,65L275,65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M225.6,318c45.7,2.9,115.9-1.6,117.6-23.3c0,0-3.2,8.2-37.8,14.7c-39,7.3-87.1,6.5-115.7,1.8 C189.8,311.2,195.6,316.1,225.6,318L225.6,318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.1,356.8h-1.4V356h3.7v0.8h-1.4v3.9h-1L341.1,356.8L341.1,356.8L341.1,356.8z M348.6,357L348.6,357 l-1.4,3.7h-0.6l-1.4-3.7h0v3.7h-0.9V356h1.3l1.3,3.3l1.3-3.3h1.3v4.7h-0.9L348.6,357L348.6,357z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.2,400.6c-4.3,3.7-8.9,5.8-13,5.8c-5.8,0-9-3.5-9-9.1c0-6.1,3.4-10.5,16.9-10.5h5V400.6L218.2,400.6 L218.2,400.6z M230.1,414v-41.5c0-10.6-6.1-17.6-20.6-17.6c-8.5,0-16,2.1-22.1,4.8l1.7,7.4c4.8-1.8,11-3.4,17-3.4 c8.4,0,12,3.4,12,10.4v5.3H214c-20.4,0-29.6,7.9-29.6,19.8c0,10.3,6.1,16.1,17.5,16.1c7.3,0,12.8-3,18-7.5l0.9,6.3H230.1L230.1,414 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M269.8,414h-14.8l-17.9-58.1h13l11.1,35.7l2.5,10.7c5.6-15.5,9.6-31.3,11.5-46.4h12.6 C284.3,375.1,278.3,396.1,269.8,414L269.8,414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.7,400.6c-4.3,3.7-8.9,5.8-13,5.8c-5.8,0-9-3.5-9-9.1c0-6.1,3.4-10.5,16.9-10.5h5L326.7,400.6L326.7,400.6 L326.7,400.6z M338.6,414v-41.5c0-10.6-6.1-17.6-20.7-17.6c-8.5,0-16,2.1-22.1,4.8l1.7,7.4c4.8-1.8,11-3.4,17-3.4 c8.4,0,12,3.4,12,10.4v5.3h-4.2c-20.4,0-29.6,7.9-29.6,19.8c0,10.3,6.1,16.1,17.5,16.1c7.4,0,12.8-3,18-7.5l0.9,6.3H338.6 L338.6,414z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st1",
    d: "M171.3,423.9c-3.4,5-8.9,8.9-14.9,11.1l-5.9-6.9c4.6-2.3,8.5-6.1,10.3-9.6 c1.6-3.1,2.2-7.2,2.2-16.8v-66.3h12.6v65.4C175.7,413.6,174.7,418.8,171.3,423.9L171.3,423.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.799fbfb5362634b5a8d18a3f23fbed67.svg";
export { ForwardRef as ReactComponent };